@if (display$ | async; as display) {
  <div
    class="flex h-full flex-col gap-2 rounded-md border border-solid border-slate-200 p-2"
    [ngClass]="{
      'bg-white': !placeholder(),
      'bg-slate-100': placeholder(),
      '!border-primary-500 border-2': display.chart.isPlaceholder
    }"
  >
    <div class="flex min-h-[40px] flex-row items-center gap-0.5">
      <div class="flex grow flex-col">
        <div class="text-xs leading-none opacity-50">{{ sectionName }}</div>
        <h3 class="!m-0">{{ display.chart | map: getLabel : this | async }}</h3>
      </div>

      @if (canResetFilter$ | async) {
        <button
          mat-icon-button
          color="primary"
          matTooltip="Reset Filters"
          class="icon-sm"
          (click)="resetFilter()"
        >
          <mat-icon>restart_alt</mat-icon>
        </button>
      }
      <ng-content select="report-builder-chart-action" />
    </div>

    @if (placeholder()) {
      <div
        class="flex min-h-[240px] min-w-[240px] grow flex-col items-center justify-center gap-2"
      >
        @if (display.chart.isPlaceholder) {
          <div
            class="flex h-full w-full cursor-pointer flex-col items-center justify-center gap-2"
            [matTooltip]="display.chart.placeholderMessage"
            (click)="edit.emit()"
          >
            <mat-icon class="text-primary-500">
              {{ placeholder()?.icon }}
            </mat-icon>
            <div class="text-primary-500 max-w-[200px] px-4 text-center">
              {{ placeholder()?.message }}
            </div>
          </div>
        } @else {
          <mat-icon
            class="text-slate-500 opacity-50"
            fontSet="material-symbols"
          >
            {{ placeholder()?.icon }}
          </mat-icon>
          <div class="text-xs text-slate-500 opacity-50">
            {{ placeholder()?.message }}
          </div>
        }
      </div>
    }

    @if (display.chartDisplay) {
      <div
        class="flex grow"
        [ngClass]="{
          'pointer-events-none': store.isLoading$ | async,
          hidden: placeholder()
        }"
      >
        <pr-dc-chart
          #dcChart
          [chartClasses]="display.chartDisplay.chartClasses"
          [chart]="display.chartDisplay.chart"
          [legend]="display.chartDisplay.legend"
          [tooltip]="display.chartDisplay.tooltip"
          [autoResize]="false"
          [crossfilter]="store.ndx$ | async"
          [hideReset]="true"
        />
      </div>
    }

    @if (display.tableDisplay) {
      <div class="flex grow" [ngClass]="{ hidden: placeholder() }">
        <pr-report-builder-table-chart
          [sectionName]="sectionName"
          [display]="display"
          [crossfilter]="store.ndx$ | async"
          [readOnly]="readOnly"
        />
      </div>
    }

    <ng-content select="report-builder-chart-bottom" />
  </div>
}
